export default function initActionsTabs () {
	const actions = document.querySelectorAll('.actions__item')
	const actionsButtons = document.querySelectorAll('.actions__item-content-button')

	if (!actions || !actionsButtons) return;

	actions.forEach((el) => {
		el.addEventListener('click', (event) => {
			if (window.innerWidth > 1000) {
				event.preventDefault();
			}
		})
	})

	actionsButtons.forEach(el => {
		el.addEventListener('click', (event) => {
			const link = event.target.href
			window.location = link
		})
	})
}
